import { ApolloError, gql, useMutation } from "@apollo/client";
import {
  EditLinkServiceInput,
  EditLinkServiceMutation,
  EditLinkServiceMutationVariables,
} from "../generated/graphql";

const EDIT_LINKSERVICE_MUTATION = gql`
  mutation editLinkService($input: EditLinkServiceInput!) {
    editLinkService(input: $input) {
      ok
      err
    }
  }
`;
export interface IEditLinkServiceInput {
  linkServiceId: number;
  isActive?: boolean;
  name: string;
  minAmount?: number;
  address?: string;
  operationFrom?: string;
  operationTo?: string;
  useDeliveryFee?: boolean;
}
// Mutation 응답 인터페이스
export interface IEditLinkServiceMutation {
  editLinkService: {
    ok: boolean;
    err: string;
  };
}

// Mutation Variables 인터페이스
export interface IEditLinkServiceMutationVariables {
  input: IEditLinkServiceInput;
}
export const useEditLinkService = (
  onCompleted?: (data: IEditLinkServiceMutation) => void,
  onError?: (error: ApolloError) => void
) => {
  return useMutation<
    IEditLinkServiceMutation,
    IEditLinkServiceMutationVariables
  >(EDIT_LINKSERVICE_MUTATION, {
    onCompleted,
    onError,
  });
};
